import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '@components/home/home.component';
import { NO_PERMISSIONS } from '@models/users.model';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    // data: {
    //   animation: 'BottomUp',
    // },
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('@modules/orders/orders.module').then(m => m.OrdersModule),
    data: {
      permissions: {
        except: [NO_PERMISSIONS],
      },
    },
  },
  {
    path: 'user',
    loadChildren: () =>
      import('@modules/user/user.module').then(m => m.UserModule),
    data: {
      permissions: {
        except: [NO_PERMISSIONS],
      },
    },
  },
  {
    path: 'statistics',
    loadChildren: () =>
      import('@modules/statistics/statistics.module').then(
        m => m.StatisticsModule
      ),
    data: {
      permissions: {
        except: [NO_PERMISSIONS],
      },
    },
  },
  {
    path: 'nutrishop',
    loadChildren: () =>
      import('@modules/nutrishop/nutrishop.module').then(
        m => m.NutrishopModule
      ),
  },
  {
    path: 'products',
    loadChildren: () =>
      import('@modules/product/product-routing.module').then(
        m => m.ProductRoutingModule
      ),
  },
  {
    path: 'footer',
    loadChildren: () =>
      import('@modules/footer/footer.module').then(m => m.FooterModule),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
